import './contentBox.scss';
import { getRequired, createDiv } from '../core/domMan';
export const wrapperName = 'contentBoxWrapper';
export const identifier = 'contentBox';

export default (ownerElem) => {
    let contentBoxObj = document.getElementById(identifier);
    let left, center, right;
    if (contentBoxObj) {
        left = getRequired(`${identifier}-left`);
        center = getRequired(`${identifier}-center`);
        right = getRequired(`${identifier}-right`);

    } else {
        ownerElem = ownerElem ?? getRequired(wrapperName);
        contentBoxObj = createDiv(ownerElem, { id: identifier, className: 'mx-1 grid grid-cols-1 md:grid-cols-3 md:gap-1 items-end' });

        const columnClasses = 'contentBox mx-1 md:gap-0.5';
        left = createDiv(contentBoxObj, { id: `${identifier}-left`, className: columnClasses });
        center = createDiv(contentBoxObj, { id: `${identifier}-center`, className: columnClasses });
        right = createDiv(contentBoxObj, { id: `${identifier}-right`, className: columnClasses });
    }

    const result = { zone: contentBoxObj, left, center, right };

    result.cleanup = () => {
        const zones = [left, center, right];
        zones.forEach(elem => {
            while (elem.firstChild) {
                elem.removeChild(elem.firstChild)
            }
        });
    }

    return result;
}